export const removeUndefs = <T>(item: T): T => {
	return JSON.parse(JSON.stringify(item))
}

export const removeUndefValues = <T extends Record<string, any>>(item: T): Partial<T> => {
	const newItem = { ...item }
	Object.keys(item).forEach(key => item[key] === undefined && delete item[key])
	return newItem
}
